import type { Prototype } from "../prototype-types";

export const fabioCarmoPrototypes: Prototype[] = [
  {
    id: "fabio-test",
    name: "Fabio Test",
    path: "/fc/fabio-test",
    description: "This is just a test.",
    owner: "Fabio Carmo",
    createdAt: "2026-04-13",
    lastUpdated: "2026-04-16",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2e81d82dd070f716e56df163ddc3c9c22c0f57295a295a86cc147c47e1c8453a.png",
    creationTool: "cursor",
  },
];
